export default __webpack_public_path__ + "static/media/events-banner.7600d9d2.png";